module.exports = __webpack_public_path__ + "static/img/step-3-image-1.1d55793.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/faqNew/img/step-3-image-1.png
// module id = kOlq
// module chunks = 1